export default {
      id: "icon-arrow-right-usage",
      viewBox: "0 0 20 12",
      url: __webpack_public_path__ + "icons.svg#icon-arrow-right",
      toString: function () {
        return this.url;
      }
    }